 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"93667928","2":"commons","3":"d94ac24e","4":"29107295","5":"a571f750e989ea17dc5bdb7ed47b518df97949be","6":"d52c63a293ecfec105ce91efe64e72a9dd22c9d1","7":"component---src-pages-data-research-jsx","8":"124b008824f9f928163a448db617290fd3c00061","10":"013d56ce","11":"102ce23c","12":"408861bb","13":"5bfda8a9","14":"7b26300c","15":"8cdcd207","16":"96df499e","17":"9c2841da","18":"adc2cfec","19":"aed16997","21":"bc9bd484","22":"c0937e87","23":"c67efe15","24":"cef67206","25":"component---src-pages-404-js","26":"component---src-pages-about-jsx","27":"component---src-pages-collaborate-js","28":"component---src-pages-conference-2024-jsx","29":"component---src-pages-conference-2025-jsx","30":"component---src-pages-conference-2026-jsx","31":"component---src-pages-conference-summit-2022-jsx","32":"component---src-pages-conference-summit-2023-jsx","33":"component---src-pages-index-jsx","34":"component---src-pages-projects-action-4-inclusion-jsx","35":"component---src-pages-projects-data-analytics-js","36":"component---src-pages-projects-dear-presidents-js","37":"component---src-pages-projects-everyday-justice-js","38":"component---src-pages-projects-jsx","39":"component---src-pages-projects-m-plan-jsx","40":"component---src-pages-projects-scopra-jsx","41":"component---src-pages-projects-social-justice-cafe-jsx","42":"component---src-pages-social-justice-champion-jsx","43":"component---src-pages-summit-2020-jsx","44":"component---src-pages-summit-2024-jsx","45":"component---src-pages-summit-2025-jsx","46":"component---src-pages-summit-conference-2021-jsx","47":"component---src-templates-post-jsx","48":"component---src-templates-posts-jsx","49":"component---src-templates-topic-jsx","50":"eddba5cc","51":"eec685f4","52":"fbcda1f4","53":"fd9a2cff"}[chunkId]||chunkId) + "-" + {"0":"9a32e32b89d64c2f9a02","1":"2574238a4bc8a2533937","2":"26099971976fa1b93bdb","3":"e3342341d6c5cb5c3ea9","4":"0f840cfff88d3f9e1655","5":"080f356b03e249326e89","6":"a5f2a08dad489b50ddce","7":"8b7e13d09d93fe17aee9","8":"0565d896814d273d165c","10":"5313842efb3796dfa1a4","11":"e517dbccae8b09d05ac5","12":"6c636a2e7b7428a8a50b","13":"c2bf5edeb3a58045a833","14":"65ddd51097340bb02f21","15":"69be4b6bced10b09b22e","16":"5d51c954a1b2e115f4f0","17":"ec55e1fdfda831499aa9","18":"90f5d325bf335beae0e5","19":"9bb252eeb155ced28260","21":"ae83dd7e6a519ff91f23","22":"7d42277e70cb13d00072","23":"8771efb5319dba5c4d4e","24":"b50f399b6f5dd737dbc5","25":"eaedc25ef5edf9cf9afd","26":"dfbc6b9b5b2416afe711","27":"2784034278d580030c40","28":"487d17565bcc869977bb","29":"1ff61927f8794de605c3","30":"3a133358560dafdaab3b","31":"bb01360c6ec5cd51a72e","32":"9d3ba640887d4cf76d70","33":"a21dc5a5a084495bdb1b","34":"82a1c35ea6424bc0eedb","35":"972e8bad337d2fe67593","36":"f5403ce318a74446bbf2","37":"013d90854376d3429e8e","38":"29e1fcc1e2efda0b5084","39":"259d6b4e61c8dd13b1d0","40":"5b3e6f5ce6fe1f948006","41":"8f77e9f2135376e8b2f6","42":"1169dbd0f0faaea84523","43":"fcfafada217af3344180","44":"e4e73959afb1e5aeb64e","45":"91831a23713943ce54bc","46":"b915e1c217c5c91d8272","47":"f3311ded9b46fa2a52af","48":"772871821535e5fb37ca","49":"ccceccc975385d832f86","50":"130de902f6110c133a3f","51":"f55fa198e5e038a82df5","52":"229ab0e1abb3156dccd5","53":"d7f6c5cb0514c03f10b6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
